import React, { useState, useEffect, useMemo } from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";

import "./toolbar.component.styles.scss";
import ToolbarSettings from "../../../settings/toolbar.settings";
import { useLang } from "../../../lib/i18n";

const Toolbar: React.FC = () => {
  const { pathname } = useLocation();
  const { t, lp, otherLangPath, lang } = useLang();
  const [selectedKey, setSelectedKey] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const items = useMemo(
    () => [
      ...ToolbarSettings.filter(({ key }) => key !== "booking").map(({ key, page, titleKey, labelKey }) => ({
        key,
        label: (
          <Link to={lp(`/${page}`)} title={t(titleKey)}>
            {t(labelKey)}
          </Link>
        ),
      })),
      {
        key: "lang-switch",
        label: (
          <Link to={otherLangPath} className="lvs-toolbar__lang">
            {lang === "it" ? "EN" : "IT"}
          </Link>
        ),
      },
    ],
    [lp, t, otherLangPath, lang],
  );

  return (
    <div className="lvs-toolbar">
      <Menu
        onClick={(e) => setSelectedKey(e.key)}
        selectedKeys={[selectedKey]}
        mode="horizontal"
        className="lvs-toolbar"
        items={items}
      />
    </div>
  );
};

export default Toolbar;
